import { useFlags } from 'launchdarkly-react-client-sdk';

import DemographicsOld from './demographics';
import DemographicsNew from './demographicsNew';

export const Demographics = () => {
  const { enableBillingUpdates2 } = useFlags();

  return enableBillingUpdates2 ? <DemographicsNew /> : <DemographicsOld />;
};
